module.exports = __webpack_public_path__ + "img/A9A2A0_2F211C_544440_6D5E5A-256px.4588c9ec.png";